<template>
    <div>
    
        <h1> Update Email Template Details </h1>
    
        <div class="box">
    
          <Errors/>
    
          <form class="form" v-on:submit.prevent="updateEmailTemplate">
    
            <EmailTemplateFields />
    
            <div class="form-wrap form-submit">
              <div v-if="this.getLoadStatus">
                <button type="submit" class="button" disabled>Creating...</button>
              </div>
              <div v-else>
                <button type="submit" class="button" v-if="userRole == 1">Update Template</button>
              </div>
            </div>
    
          </form>
    
        </div>
    
    </div>
    
    </template>
    
    <script>

    import EmailTemplateFields from '@/components/EmailTemplateFields.vue'

    import Errors from '@/components/Errors.vue'

    import {mapGetters} from 'vuex'

    // import juice from 'juice';

    export default {

      name: 'EmailTemplteEdit',

      computed: {
        ...mapGetters(['getLoadStatus']),
        userRole() {
          return localStorage.getItem("user_role");
        },
      },

      data () {
        return {
          template: {},
          errors: null
        }
      },
      components: {
        EmailTemplateFields,
        Errors
      },
      created () {
        this.getEmailTemplate()
      },
      watch: {
        '$route': 'getEmailTemplate'
      },
      methods: {
        getEmailTemplate () {
          this.$store.dispatch('setLoadStatus')
          fetch(this.$api + 'email-templates/' + this.$route.params.id + '/template', {
              headers: {
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
              }
            })
          .then(res => res.json())
          .then(response => {
            this.$store.dispatch('setLoadStatus')
            this.template = {
              template_handling: 'edit',
              nature: response.data.nature,
              template_type: response.data.template_type,
              template_name: response.data.template_name,
              template_slug: response.data.template_slug,
              template_subject:response.data.template_subject,
              template_status: response.data.status,
              selected_doc_types: response.data.selected_doc_types,
              template_body_content:response.data.template_body_content,
            }
          })
        },
        updateEmailTemplate () {
          this.$store.dispatch('setLoadStatus')

            let {template_name, nature, template_type, template_slug, template_subject, template_status, template_body_content, selected_doc_types} = this.template;

            const juice = require('juice');
            const inlineHtml = juice(template_body_content);
            
            let templateObject = {
                title : template_name,
                nature: nature,
                type:template_type,
                slug: template_slug,
                subject: template_subject,
                body_content: inlineHtml,
                selected_doc_types,
                status : (template_status) ? 1 : 0
            }

          fetch(this.$api + 'email-templates/' + this.$route.params.id + '/update', {
            method: 'POST',
            body: JSON.stringify(templateObject),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          })
          .then(res => res.json())
          .then(response => {
            if(response.status) {
              this.$router.push({ name: 'email-template'})
              this.$notify({
                  type: 'success',
                  title: response.message
              });
            } else if (response.errors) {
              this.$notify({
                type: 'error',
                title: response.message
              });
            }
            this.$store.dispatch('setLoadStatus')
          });
        }
      }
    }
    </script>
    